import React, { FC, useRef } from "react";
import { Banner } from "src/page-components/about-us/Banner";
import { CompanyMission } from "src/page-components/about-us/CompanyMission";
import { PromoBanner } from "src/page-components/about-us/PromoBanner";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { MetadataWrapper } from "src/components/MetadataWrapper";

const AboutUs: FC = () => {
  const sectionRef = useRef(null);

  return (
    <MetadataWrapper name="about_us">
      <PageWrapper
        mainClassName="flex flex-col pb-15 lg:pb-20"
        isShownHeader={false}
      >
        <Banner sectionRef={sectionRef} />
        <CompanyMission sectionRef={sectionRef} />
        <PromoBanner />
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default AboutUs;
